import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import * as Tabs from '@radix-ui/react-tabs';
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
import type { SegmentedControlSize, SegmentedControlVariant } from '../../segmented-control';
export type SegmentedControlOptionFields<T extends string = string> = {
  value: T;
  label: ReactNode;
  icon?: Icon;
  size?: SegmentedControlSize;
  variant?: SegmentedControlVariant;
};
export type SegmentedControlOptionProps = SegmentedControlOptionFields & {
  selected?: boolean;
};
const SegmentedControlOption = t0 => {
  const $ = _c(17);
  const {
    value: optionValue,
    label,
    icon: Icon,
    selected,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const variant = t2 === undefined ? "primary" : t2;
  let t3;
  if ($[0] !== size || $[1] !== variant) {
    t3 = cx("border-none rounded-full flex justify-center items-center gap-1.5", "data-[state=active]:bg-elevated data-[state=active]:text-primary data-[state=active]:shadow-[0px_0px_2px_rgba(0,0,0,0.15)]", "data-[state=inactive]:cursor-pointer data-[state=inactive]:text-tertiary", {
      "data-[state=inactive]:bg-canvas data-[state=inactive]:hover:bg-hover-control": variant === "primary",
      "data-[state=inactive]:bg-senary data-[state=inactive]:hover:bg-hover-control": variant === "secondary"
    }, {
      "py-0.5 px-3": size === "compact",
      "py-1 px-3": size === "default"
    });
    $[0] = size;
    $[1] = variant;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== Icon) {
    t4 = Icon && <Icon />;
    $[3] = Icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !selected;
  let t6;
  if ($[5] !== selected || $[6] !== t5) {
    t6 = cx("text-primary", {
      "text-label-2": selected,
      "text-body-2": t5
    });
    $[5] = selected;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== label || $[9] !== t6) {
    t7 = <div className={t6}>{label}</div>;
    $[8] = label;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== optionValue || $[12] !== selected || $[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t8 = <Tabs.Trigger value={optionValue} key={optionValue} data-selected={selected} className={t3}>{t4}{t7}</Tabs.Trigger>;
    $[11] = optionValue;
    $[12] = selected;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default SegmentedControlOption;